// Slick Carousel
import Glide from "@glidejs/glide";

class CarouselOnePictureMargins {
  constructor() {
    // element that will be wrapped
    const carousel = document.querySelector('.carousel-one-picture-margins');

    if (carousel) {
      console.log("carousel loaded")
      const carouselTrack = document.querySelector(
        '.carousel-one-picture-margins .wp-block-group'
      );
      const carouselSlides = carouselTrack.querySelector(
        '.carousel-one-picture-margins .wp-block-group .wp-block-group'
      );
      const carouselIndividualSlide = carouselTrack.querySelectorAll(
        '.carousel-one-picture-margins .wp-block-group .wp-block-group .wp-block-image'
      );

      // Add Glide classes
      carouselTrack.classList.add("glide__track");
      carouselTrack.dataset.glideEl = "track";
      carouselSlides.classList.add("glide__slides");
      carouselIndividualSlide.forEach((item) => {
        item.classList.add("glide__slide");
      });

      // Tweak styles
      carousel.style.overflow = "hidden";
      carouselSlides.style.flexWrap = "nowrap";

      // Add arrows
      carousel.insertAdjacentHTML(
        "beforeend",
        `<div class="glide__arrows" data-glide-el="controls">
                <button class="glide__arrow glide__arrow--left" data-glide-dir="<"><i class="fa-solid fa-chevron-left"></i></button>
                <button class="glide__arrow glide__arrow--right" data-glide-dir=">"><i class="fa-solid fa-chevron-right"></i></button>
            </div>`
      );

      // Mount carousel
      var threeSlideGlide = new Glide(".carousel-one-picture-margins", {
        type: "carousel",
        perView: 1,
        autoplay: 4000,
      }).mount();
    }
  }
}

export default CarouselOnePictureMargins;
